/* ============================================================
   VEXA LUMEN V2 — Interacciones adicionales (vanilla JS)
   Capa independiente: no modifica vexa-lumen.js
   ============================================================ */
(function () {
  'use strict';

  var V = window.VEXA || { moneyFormat: '€{{amount_with_comma_separator}}' };

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function formatMoney(cents, format) {
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var f = format || V.moneyFormat;
    function fixed(c, p, t, d) {
      p = typeof p === 'undefined' ? 2 : p;
      t = typeof t === 'undefined' ? '.' : t;
      d = typeof d === 'undefined' ? ',' : d;
      if (isNaN(c) || c == null) c = 0;
      c = (c / 100).toFixed(p);
      var parts = c.split('.');
      var euros = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + t);
      var dec = parts[1] ? d + parts[1] : '';
      return euros + dec;
    }
    switch ((f.match(placeholderRegex) || [])[1]) {
      case 'amount': value = fixed(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = fixed(cents, 0); break;
      case 'amount_with_comma_separator': value = fixed(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fixed(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fixed(cents, 2, "'", '.'); break;
      default: value = fixed(cents, 2, '.', ',');
    }
    return f.replace(placeholderRegex, value);
  }

  /* ---------- Barra de anuncios: rotación de mensajes ---------- */
  $$('[data-announcement-rotator]').forEach(function (bar) {
    var items = $$('.announcement__item', bar);
    if (items.length < 2 || reduced) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4200);
  });

  /* ---------- Contadores animados (banda de cifras) ---------- */
  (function () {
    var counters = $$('[data-counter]');
    if (!counters.length) return;
    function animate(el) {
      var target = parseFloat(el.getAttribute('data-counter')) || 0;
      if (reduced || !target) { el.textContent = target; return; }
      var dur = 1400;
      var start = null;
      function tick(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 4);
        el.textContent = Math.round(target * eased);
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }
    if (!('IntersectionObserver' in window)) {
      counters.forEach(function (el) { el.textContent = el.getAttribute('data-counter'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { animate(en.target); io.unobserve(en.target); }
      });
    }, { threshold: 0.4 });
    counters.forEach(function (el) { io.observe(el); });
  })();

  /* ---------- Pill "Ahorras X €" en la ficha de producto ----------
     El JS base re-renderiza el precio al cambiar de variante sin la pill;
     aquí se recalcula y se vuelve a insertar después de cada cambio. */
  (function () {
    var root = $('[data-product-root]');
    if (!root) return;
    var dataEl = $('#ProductData', root);
    if (!dataEl) return;
    var product;
    try { product = JSON.parse(dataEl.textContent); } catch (err) { return; }

    function updatePill() {
      var idInput = root.querySelector('form[data-ajax-cart] [name="id"]');
      var box = root.querySelector('[data-price-box]');
      if (!idInput || !box) return;
      var v = null;
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === String(idInput.value)) { v = product.variants[i]; break; }
      }
      if (!v) return;
      var existing = box.querySelector('.savings-pill');
      if (v.compare_at_price && v.compare_at_price > v.price) {
        var txt = 'Ahorras ' + formatMoney(v.compare_at_price - v.price);
        if (existing) { existing.textContent = txt; }
        else {
          var s = document.createElement('span');
          s.className = 'savings-pill';
          s.textContent = txt;
          box.appendChild(s);
        }
      } else if (existing) {
        existing.remove();
      }
    }
    root.addEventListener('change', function () { setTimeout(updatePill, 0); });
  })();
})();
